export enum platformEnum {
    WEB = 'WEB',
    ELECTRON = 'ELECTRON',
    MOBILE = 'MOBILE',
}

export default () => {
    if (typeof window !== 'undefined') {
        // @ts-ignore
        if (window.FocusSDK && window.FocusSDK.getAuthInfo) {
            return platformEnum.ELECTRON;
        }
        return platformEnum.WEB;
    }
    return "";
};
